import { render, staticRenderFns } from "./AssessmentReportEditHeadingDialog.vue?vue&type=template&id=c00d0ef0&"
import script from "./AssessmentReportEditHeadingDialog.vue?vue&type=script&lang=ts&"
export * from "./AssessmentReportEditHeadingDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports